module.exports = __webpack_public_path__ + "static/media/GreeceBlocks_3_2_1.b23e0a5d.png";